export default "__VITE_ASSET__BN2$DItE__"